module.exports = __webpack_public_path__ + "img/GRC-alt.dac4457d.svg";